import { v3 } from '@adobe/edex/frontend/api/v3';
import { AxiosRequestConfig } from 'axios';

const baseURL = `/resources`;

export function paginate(config: AxiosRequestConfig) {
  return v3.get(baseURL, config);
}

export function list({ courseID, workshopID, query, offset, order, limit }) {
  const params = {
    filterBy: `courseID:${courseID},workshopID:${workshopID}`,
    q: query,
    offset,
    limit,
    order,
  };
  return v3.get(baseURL, { params });
}

export function listDrafts(config: AxiosRequestConfig) {
  return v3.get(`${baseURL}/drafts`, config);
}

export function listPublished(config: AxiosRequestConfig) {
  return v3.get(`${baseURL}/published`, config);
}

export function listFavorite(config: AxiosRequestConfig) {
  return v3.get(`${baseURL}/favorite`, config);
}

export function listFeatured() {
  return v3.get(`${baseURL}/featured`);
}

export function get(vanityURL) {
  return v3.get(`${baseURL}/${vanityURL}`);
}

export function create(payload) {
  return v3.post(baseURL, payload);
}

export function update({ id, ...payload }) {
  return v3.put(`${baseURL}/${id}`, payload);
}

export function remove(id) {
  return v3.delete(`${baseURL}/${id}`);
}
